import React, { Component, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'reactstrap';
import Modal from '@material-ui/core/Modal';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import AdvancedSearchListEvents from './AdvancedSearchListEvents';
import AdvancedSearchListEventsActions from './AdvancedSearchListEventsActions';
import Spinner from 'react-bootstrap/Spinner';

class SearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      openSearch: false,
      documentNumber: "",
      names: "",
      firstLastName: "",
      secondLastName: "",
      eventsPatients: []
    };
  };

  componentDidMount = () => {
    
  }

  validateAllFields = () => {
    if (
      (this.state.documentNumber == "" || this.state.documentNumber == null) &&
      (this.state.names == "" || this.state.names == null) &&
      (this.state.firstLastName == "" || this.state.firstLastName == null) &&
      (this.state.secondLastName == "" || this.state.secondLastName == null)) {
      return false;
    }
    else {
      return true;
    }
  }

  handlerOpenSearch = (close) => {
    this.setState({ openSearch: close })
  };

  handlerNames = (names) => {
    this.setState({ names: names });
  }

  handlerFirstLastName = (firstLastName) => {
    this.setState({ firstLastName: firstLastName });
  }

  handlerSecondLastName = (secondLastName) => {
    this.setState({ secondLastName: secondLastName });
  }

  handlerDocumentNumber = (documentNumber) => {
    this.setState({ documentNumber: documentNumber });
  }

  handlerSearchAppointments = async () => {
  
    let validate = this.validateAllFields();
    if(!validate)
    {
      alert("Debe especificar como minimo un parametro de busqueda");
      return;
    }
    
    this.setState({ isLoading: true });
    var dateCalendar = new Date(this.props.referenceDate);
    var dateStart = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth(), 1);
    var dateEnd = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth() + 1, 0);
    let dataSend = {
      f_inicio: moment(dateStart).format("YYYY/MM/DD"),
      f_fin: moment(dateEnd).format("YYYY/MM/DD"),
      id: 0,
      num_documento: this.state.documentNumber,
      nombres: this.state.names,
      apellido1: this.state.firstLastName,
      apellido2: this.state.secondLastName
    }

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultar-pacientes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.existe == true) {
        this.setState({ eventsPatients: data.contenido, isLoading: false });
      }
      else {
        this.setState({ eventsPatients: [], isLoading: false });
      }
    }).catch((error) => {
      console.error('Error:', error);
      this.setState({ isLoading: false });
    });
  }

  render() {

    const setDataEvent = (event) => {
      this.props.setData(event);
    }

    const ListEventsAdvancedSearchTable = () => {
      return (
        <AdvancedSearchListEvents
          reactTableData={this.state.eventsPatients}
          ReactTableActions={AdvancedSearchListEventsActions}
          setDataEvent={setDataEvent}
          configPageSize={5}
          isAdvancedSearch={true}
        />);
    }

    return (
      <>
        <Tooltip title="Buscar Paciente">
          {
            <Button onClick={() => {this.handlerOpenSearch(true)}} > <SearchIcon /></Button>
          }
        </Tooltip>
        <Modal
          open={this.state.openSearch}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
          onClose={() => {
            this.handlerOpenSearch(false);
          }}
        >
          <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
            <h4 className="bold-text">Buscar Paciente</h4>
            <Row>
              <Col md={3}>
                <TextField
                  required
                  className="medical-material-form__field"
                  id="txtDocumentNumber"
                  label="Número de Documento"
                  type="text"
                  InputLabelProps={{
                    style: { color: '#646777' }
                  }}
                  value={this.state.documentNumber}
                  onChange={(e) => {
                    this.handlerDocumentNumber(e.target.value);

                  }}
                  disabled={this.state.disabledInput}
                />
              </Col>
              <Col md={3}>
                <TextField
                  required
                  className="medical-material-form__field"
                  id="txtNames"
                  label="Nombres"
                  InputLabelProps={{
                    style: { color: '#646777' }
                  }}
                  type="text"
                  value={this.state.names}
                  onChange={(e) => {
                    this.handlerNames(e.target.value);

                  }}
                  disabled={this.state.disabledInput}
                />
              </Col>
              <Col md={3}>
                <TextField
                  required
                  className="medical-material-form__field"
                  id="txtFirstLastName"
                  label="Primer Apellido"
                  type="text"
                  InputLabelProps={{
                    style: { color: '#646777' }
                  }}
                  value={this.state.firstLastName}
                  disabled={this.state.disabledInput}
                  onChange={(e) => {
                    this.handlerFirstLastName(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <TextField
                  className="medical-material-form__field"
                  id="txtSecondLastName"
                  label="Segundo Apellido"
                  type="text"
                  InputLabelProps={{
                    style: { color: '#646777' }
                  }}
                  value={this.state.secondLastName}
                  disabled={this.state.disabledInput}
                  onChange={(e) => {
                    this.handlerSecondLastName(e.target.value);
                  }}
                />
              </Col>
              <Col md={12}>
                {this.state.isLoading ? <div className="text-center">
                  <Spinner animation="border" variant="success" />
                </div> : <ListEventsAdvancedSearchTable />}
              </Col>
            </Row>
            <div style={{ display: 'flex', marginTop: 10, justifyContent: 'flex-end' }}>
              <Button
                style={{ marginRight: 10, marginLeft: 10 }}
                variant="contained"
                onClick={() => {
                  this.handlerOpenSearch(false);
                }}
              >
                Cerrar
              </Button>
              <Button
                style={{ marginRight: 10, marginLeft: 10 }}
                variant="contained"
                color='primary'
                onClick={() => {
                  this.handlerSearchAppointments();
                }}
              >
                Buscar
              </Button>
            </div>
          </div>
        </Modal>
      </>);
  }
}

export default SearchModal;
